import type { Performer } from '@brent/shared/types'
import apiClient from './client'

export interface PerformerListResponse {
  performers: Performer[]
}

export interface PerformerConcert {
  concert_id: number
  date_text: string | null
  date_iso: string | null
  year: number | null
  venue_name: string | null
  ensemble_name: string | null
  role: string | null
}

export interface PerformerDetailResponse {
  performer: Performer
  concerts: PerformerConcert[]
}

export interface UpdatePerformerInput {
  quality_score?: string
  wikidata_id?: string
}

export interface UpdatePerformerResponse {
  ok: boolean
  enriched?: {
    label: string
    description: string
    birth_year: number
    death_year: number
  }
  cleared?: boolean
  error?: string
}

export interface MoveToNotesResponse {
  ok: boolean
  concerts_updated: number
  error?: string
}

export async function fetchPerformers(): Promise<Performer[]> {
  const response = await apiClient.get<PerformerListResponse>('/performers')
  return response.performers
}

export async function fetchPerformer(id: number): Promise<PerformerDetailResponse> {
  return apiClient.get<PerformerDetailResponse>(`/performers/${id}`)
}

export async function updatePerformer(
  id: number,
  input: UpdatePerformerInput,
): Promise<UpdatePerformerResponse> {
  return apiClient.put<UpdatePerformerResponse>(`/performers/${id}`, input)
}

export async function moveToNotes(id: number): Promise<MoveToNotesResponse> {
  return apiClient.put<MoveToNotesResponse>(`/performers/${id}/move-to-notes`, {})
}
